import { render, staticRenderFns } from "./TableTopForceActive.vue?vue&type=template&id=ccbdc23c"
import script from "./TableTopForceActive.vue?vue&type=script&lang=js"
export * from "./TableTopForceActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports